import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { TaskList as TaskListComponent } from './TaskList';
import { TaskList as TaskListWithSSEComponent } from './TaskListWithSSE';

const TaskList = () => {
  const isEnableRefreshTask = useFeatureIsOn('cf-1116-optimize-live-map');
  if (isEnableRefreshTask) return <TaskListWithSSEComponent />;
  return <TaskListComponent />;
};

export { TaskList };
